/** Shared bank transfer details for invoices and customer UI */
export const SPIRES_BANK_DETAILS = {
  accountName: "Spires Taxis LTD",
  sortCode: "04-06-05",
  accountNumber: "27751218",
} as const;

export function isBankTransferMethod(method?: string | null): boolean {
  if (!method) return false;
  const n = method.toLowerCase().replace(/_/g, " ").trim();
  return n === "bank transfer" || n === "banktransfer" || n.includes("bank");
}

export function formatPaymentMethodLabel(method?: string | null): string {
  const raw = String(method || "").trim();
  const n = raw.toLowerCase().replace(/_/g, " ");
  if (!raw) return "To be confirmed";
  if (n === "tbc") return "TBC";
  if (n === "undecided") return "Not decided yet";
  return raw.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function confirmationPaymentLabel(method?: string | null): string {
  const raw = String(method || "").trim();
  const n = raw.toLowerCase().replace(/_/g, " ");
  if (!raw) return "TO BE CONFIRMED";
  if (n === "tbc") return "TBC";
  if (n === "undecided") return "NOT DECIDED YET";
  return raw.replace(/_/g, " ").toUpperCase();
}

/** HTML block for PDFs / emails when customer will pay by bank transfer */
export function bankTransferDetailsHtml(opts?: {
  unpaidOnly?: boolean;
  paymentStatus?: string;
  bookingNumber?: string;
}): string {
  if (opts?.unpaidOnly && opts.paymentStatus === "paid") return "";
  if (opts?.paymentStatus === "paid") return "";
  const { accountName, sortCode, accountNumber } = SPIRES_BANK_DETAILS;
  const ref = (opts?.bookingNumber || "").trim();
  return `
    <div style="margin-top:12px;padding:12px;border:1px solid #C5A572;border-radius:8px;background:#faf8f4;font-size:0.9rem;line-height:1.55;color:#002147;text-align:left;">
      <div style="font-weight:700;color:#002147;margin-bottom:8px;">Bank transfer details</div>
      <div style="color:#002147;"><strong>Account name:</strong> ${accountName}</div>
      <div style="color:#002147;"><strong>Sort code:</strong> ${sortCode}</div>
      <div style="color:#002147;"><strong>Account number:</strong> ${accountNumber}</div>
      <div style="margin-top:8px;font-size:0.85rem;color:#333;">
        Please use ${ref ? `<strong>${ref}</strong> as` : "your booking number as"} the payment reference.
      </div>
    </div>
  `;
}

export function bankTransferDetailsPlainText(): string {
  const { accountName, sortCode, accountNumber } = SPIRES_BANK_DETAILS;
  return [
    "Pay by bank transfer:",
    `Account name: ${accountName}`,
    `Sort code: ${sortCode}`,
    `Account number: ${accountNumber}`,
    "Please use your booking number as the payment reference.",
  ].join("\n");
}
